
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Index from './pages/Index';
import Wishlist from './pages/Wishlist';
import Account from './pages/Account';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import { setupAuthErrorHandling, clearAuthStorage } from './utils/authCleanup';
import { supabase } from './integrations/supabase/client';
import { useQueryClient } from '@tanstack/react-query';

const App = () => {
  const queryClient = useQueryClient();

  // Set up global auth error handling
  useEffect(() => {
    console.log("Setting up auth error handling in App component");
    
    // Setup auth error detection
    const cleanup = setupAuthErrorHandling();
    
    // Clean up on unmount
    return cleanup;
  }, []);

  // No need for token validation on startup since we're now using non-persistent sessions
  // This ensures users must authenticate on each page refresh

  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Index />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="account" element={<Account />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
